import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { MovieCard } from "../MovieCard/MovieCard";
import styles from "./MoviesGrid.module.scss";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { moviesSlice } from "@common/redux/slices/entities.slice";
import { IMovie } from "@common/redux/types/movie";
import { getCardTypeByIdx } from "@kursk/utils/getCardTypeByIdx";
import { useOrientations } from "@common/hooks/useOrientation";
import { useCallback } from "react";

export function MoviesGrid() {
  const { items, total, offset } = useSelectSlice(moviesSlice);
  const orientation = useOrientations()
  const getCardType = useCallback((index) => {
    return getCardTypeByIdx(index, orientation)
  }, [orientation])

  return (
    <EntitiesGrid
      <IMovie>
      entityType="movies"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IMovie, index) => <MovieCard key={item._id} movie={item}
        type={getCardType(index)}
        customStyle={styles}/>}
    />
  );
}
